// src/components/CustomSnackbarContent.jsx
import React from "react";
import { IconButton } from "@mui/material";
import { Icons } from "../../config/MuiIcons.config";
import { AppTheme } from "../../theme/App.theme";

const CustomSnackbar = ({ variant, message, onClose }) => {
  const variantStyles = {
    success: {
      bg: "#E9F9EE",
      icon: <Icons.CheckCircle fontSize="medium" sx={{ color: "#219653" }} />,
      title: "Success",
    },
    error: {
      bg: "#FDEDED",
      icon: <Icons.Error fontSize="medium" sx={{ color: "#D32F2F" }} />,
      title: "Error",
    },
    warning: {
      bg: "#FFF4E5",
      icon: <Icons.Warning fontSize="medium" sx={{ color: "#ED6C02" }} />,
      title: "Warning",
    },
    info: {
      bg: "#E3F2FD",
      icon: <Icons.InfoIcon fontSize="medium" sx={{ color: "#0288D1" }} />,
      title: "Info",
    },
  };

  const style = variantStyles[variant] || variantStyles?.info;

  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          // alignItems: "center",
          backgroundColor: "#fff", // make entire box white
          borderRadius: "8px",
          overflow: "hidden",
          width: "100%",
          maxWidth: "500px",
          position: "relative",
          boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
        }}
      >
        {/* Icon Section */}
        <div
          style={{
            backgroundColor: style.bg, // apply color just here
            padding: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          {style.icon}
        </div>

        {/* Message Section */}
        <div
          className="plus-jakarta-sans-medium-500"
          style={{
            padding: "12px 36px 12px 12px",
            background: AppTheme.PRIMARY_WHITE,
            flex: 1,
            fontSize: "14px",
            color: AppTheme.PRIMARY_BLACK,
            display: "flex",
            alignItems: "center",
            minHeight: "48px", // Minimum height to match icon section
            lineHeight: "1.4", // Better line height for readability
            wordBreak: "break-word", // Break long words if needed
            overflow: "hidden", // Hide overflow
          }}
        >
          <div
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2, // Show maximum 2 lines
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
            }}
          >
            {message}
          </div>
          {/* Close Button */}
          <div
            onClick={onClose}
            style={{
              position: "absolute",
              top: "0px",
              right: "0px",
              fontSize: "18px",
              cursor: "pointer",
              flexShrink: 0,
            }}
          >
            <IconButton>
              <Icons.Close fontSize="small" />
            </IconButton>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CustomSnackbar;
